import { render, staticRenderFns } from "./gender4.vue?vue&type=template&id=b903a794&"
import script from "./gender4.vue?vue&type=script&lang=js&"
export * from "./gender4.vue?vue&type=script&lang=js&"
import style0 from "./gender4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports